import { IntlMessagesPattern } from "./types";

// eslint-disable-next-line import/prefer-default-export
export const prependIntlIds = <
  Prefix extends string,
  Messages extends IntlMessagesPattern
>(
  prefix: Prefix,
  messages: Messages
): Record<`${Prefix}.${string & keyof Messages}`, Messages[keyof Messages]> => {
  const originalEntries = Object.entries(messages);
  const newEntries = originalEntries.map((entry) => {
    const [originalIntlId, message] = entry;

    const newIntlId = `${prefix}.${originalIntlId}`;
    return [newIntlId, message];
  });

  return Object.fromEntries(newEntries);
};

export const prefixes = {
  toast: "toast",
  pageTitle: "page_title",
  hegMapping: "heg_mapping",
  feedback: "feedback",
  tBuilderValidation: "TBValidation",
  versionTableHeader: "version_table_header",
} as const;
